import * as React from 'react';
import { toast } from 'sonner';

import { Campo } from '@/componentes/campo';
import { Celula } from '@/componentes/celula';
import { Carregando, Falha } from '@/componentes/estado-da-tela';
import { Button } from '@/componentes/ui/button';
import { Input } from '@/componentes/ui/input';
import { Valor } from '@/componentes/valor';
import { mensagemDoErro, useAdministradores, useDefinirPapel } from '@/dados';

/* Quem tem o painel.
 *
 * Promoção por E-MAIL, não por identificador: quem administra conhece a pessoa
 * pelo e-mail, e pedir um uuid transformaria a operação em consulta ao banco.
 *
 * A recusa de remover o administrador permanente vem da API, não daqui: regra
 * que só existe no botão desaparece na primeira chamada feita por fora. */

export function Papeis() {
  const admins = useAdministradores();
  const definir = useDefinirPapel();
  const [email, setEmail] = React.useState('');

  const promover = (evento: React.FormEvent) => {
    evento.preventDefault();
    definir.mutate(
      { email, papel: 'admin' },
      {
        onSuccess: () => {
          setEmail('');
          toast.success('Administrador adicionado.');
        },
        onError: (erro) => toast.error(mensagemDoErro(erro)),
      },
    );
  };

  const remover = (alvo: string) => {
    definir.mutate(
      { email: alvo, papel: 'dono' },
      {
        onSuccess: () => toast.success('Acesso ao painel removido.'),
        onError: (erro) => toast.error(mensagemDoErro(erro)),
      },
    );
  };

  return (
    <div className="grid gap-4 @coluna-larga:grid-cols-2">
      <Celula respiro="folgado" className="grid gap-3">
        <h3 className="titulo-bloco">Dar acesso ao painel</h3>
        <form className="grid gap-3" onSubmit={promover}>
          <Campo rotulo="E-mail da conta" ajuda="A conta precisa já existir, com e-mail e senha." obrigatorio>
            {(atributos) => (
              <Input
                {...atributos}
                type="email"
                value={email}
                onChange={(evento) => setEmail(evento.target.value)}
                placeholder="pessoa@empresa.com.br"
                required
              />
            )}
          </Campo>
          <div>
            <Button type="submit" disabled={definir.isPending || email.trim() === ''}>
              Dar acesso
            </Button>
          </div>
        </form>
      </Celula>

      <Celula respiro="folgado" className="grid gap-3">
        <h3 className="titulo-bloco">Com acesso hoje</h3>
        {admins.isError ? (
          <Falha
            oQue="a lista de administradores"
            motivo={mensagemDoErro(admins.error)}
            aoTentarDeNovo={() => void admins.refetch()}
          />
        ) : admins.isPending ? (
          <Carregando linhas={1} rotulo="Carregando os administradores." />
        ) : (
          <ul className="grid gap-2">
            {admins.data.map((admin) => (
              <li key={admin.id} className="flex items-center justify-between gap-3">
                <div className="grid min-w-0">
                  <span className="text-apoio truncate">{admin.email}</span>
                  <span className="text-tinta-2 text-nota">
                    Último acesso <Valor valor={admin.ultimo_acesso} formato="data" />
                  </span>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  disabled={definir.isPending}
                  onClick={() => admin.email && remover(admin.email)}
                >
                  Remover
                </Button>
              </li>
            ))}
          </ul>
        )}
      </Celula>
    </div>
  );
}
